//@ts-nocheck
import React, { useEffect, useLayoutEffect } from 'react';
import 'aos/dist/aos.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import CosmicOrbitLoader from '../components/CosmicOrbitLoader';
import $ from 'jquery';
import 'slick-carousel';
import { dynamicLoader } from '../helpers/helpers';
import './styles.css'
import Navbar from './components/Navbar';
import WebToPdfSection from './components/sections/WebToPdfSection';
import PackagesSection from './components/sections/PackagesSection';
import { useLocation } from 'react-router-dom'; // Import useLocation
import ContactUsSection from './components/sections/ContactUSSection';
import { Helmet } from 'react-helmet'; // Import Helmet
import DesktopModal from './components/DesktopModal';
import Footer from './components/Footer';

const WebToPDF = () => {
    const [showPreloader, setShowPreloader] = React.useState(true);
    const [showDesktopModal, setShowDesktopModal] = React.useState(false);
    const [blogPosts, setBlogPosts] = React.useState<any[]>([]);
    const [blogLoading, setBlogLoading] = React.useState(false);

    React.useEffect(() => {
        const isAlreadyInstalled = localStorage.getItem("pwa-installed") === "true";
        const lastShown = localStorage.getItem("pwa-last-shown");
        const today = new Date().toISOString().slice(0, 10); // YYYY-MM-DD

        if (isAlreadyInstalled) {
            setShowDesktopModal(false);
            return;
        }

        // Don't show again today
        if (lastShown === today) {
            return;
        }

        const handleBeforeInstallPrompt = (e: any) => {
            e.preventDefault();

            // Show modal if not installed and not shown today
            if (!isAlreadyInstalled && lastShown !== today) {
                setShowDesktopModal(true);
                localStorage.setItem("pwa-last-shown", today);
            }
        };

        const handleAppInstalled = () => {
            localStorage.setItem("pwa-installed", "true");
            setShowDesktopModal(false);
        };

        window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
        window.addEventListener("appinstalled", handleAppInstalled);

        // Fallback check: if opened from app
        if (window.matchMedia("(display-mode: standalone)").matches) {
            localStorage.setItem("pwa-installed", "true");
            setShowDesktopModal(false);
        }

        return () => {
            window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
            window.removeEventListener("appinstalled", handleAppInstalled);
        };
    }, []);

    const handleCloseDesktopModal = () => {
        setShowDesktopModal(false);
    };

    // Fetch WordPress blog posts
    const fetchBlogPosts = async () => {
        setBlogLoading(true);
        try {
            const response = await fetch('https://webs2pdf.com/blog/wp-json/wp/v2/posts?per_page=6&_embed');
            if (!response.ok) {
                throw new Error('Failed to fetch blog posts');
            }
            const posts = await response.json();
            
            // Filter out duplicate posts by ID
            const uniquePosts = posts.filter((post: any, index: number, self: any[]) => 
                index === self.findIndex((p: any) => p.id === post.id)
            );
            
            // Sort by date (newest first) and take only the 6 latest
            const sortedPosts = uniquePosts.sort((a: any, b: any) => {
                const dateA = new Date(a.date).getTime();
                const dateB = new Date(b.date).getTime();
                return dateB - dateA; // Descending order (newest first)
            });
            
            // Ensure only 6 latest blogs are shown
            const latestPosts = sortedPosts.slice(0, 6);
            
            setBlogPosts(latestPosts);
        } catch (error) {
            console.error('Error fetching blog posts:', error);
            setBlogPosts([]);
        } finally {
            setBlogLoading(false);
        }
    };

    // Format date from WordPress format
    const formatDate = (dateString: string) => {
        const date = new Date(dateString);
        const months = ['January', 'February', 'March', 'April', 'May', 'June', 
                       'July', 'August', 'September', 'October', 'November', 'December'];
        return `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
    };

    // Get excerpt from post content
    const getExcerpt = (content: string, maxLength: number = 200) => {
        // Remove HTML tags
        const text = content.replace(/<[^>]*>/g, '');
        // Remove extra whitespace
        const cleanText = text.replace(/\s+/g, ' ').trim();
        if (cleanText.length <= maxLength) {
            return cleanText;
        }
        return cleanText.substring(0, maxLength) + '...';
    };

    // Get featured image URL
    const getFeaturedImage = (post: any) => {
        // Check for specific blog title and use custom image URL
        const postTitle = post.title?.rendered || '';
        if (postTitle === 'Save Web Pages as High-Quality PDF Without Installing Any App') {
            return 'https://webs2pdf.com/blog/wp-content/uploads/2025/12/Save-Web-Pages-as-High-Quality-PDF-Without-Installing-Any-App-scaled.jpg';
        }
        
        // Check for embedded featured media
        if (post._embedded && post._embedded['wp:featuredmedia'] && post._embedded['wp:featuredmedia'][0]) {
            return post._embedded['wp:featuredmedia'][0].source_url;
        }
        
        return 'images/blog1.webp'; // Fallback image
    };

    useEffect(() => {
        fetchBlogPosts();
    }, []);

    // Initialize blog slider after posts are loaded
    useEffect(() => {
        if (blogPosts.length > 0 && !blogLoading) {
            // Destroy existing slider if it exists
            if ($('.blog-slider').hasClass('slick-initialized')) {
                $('.blog-slider').slick('unslick');
            }
            
            // Initialize slider after a short delay to ensure DOM is ready
            setTimeout(() => {
                $('.blog-slider').slick({
                    dots: true,
                    infinite: true,
                    speed: 300,
                    arrows: false,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 0,
                    responsive: [
                        {
                            breakpoint: 992,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                                infinite: true,
                                dots: true,
                            },
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                dots: true,
                            },
                        },
                    ],
                });
            }, 100);
        }
        
        // Cleanup function
        return () => {
            if ($('.blog-slider').hasClass('slick-initialized')) {
                $('.blog-slider').slick('unslick');
            }
        };
    }, [blogPosts, blogLoading]);

    useEffect(() => {
        dynamicLoader.addScripts();
        setTimeout(() => {
            setShowPreloader(false);
        }, 500);
    }, []);

    useLayoutEffect(() => {
        // @ts-ignore
        document.getElementsByTagName('TITLE')[0].text = 'Webs2Pdf';
    }, []);

    const location = useLocation(); // Get the current route
    useEffect(() => {
        if (location.pathname === '/') {
            document.body.classList.add('home-page');
            document.body.classList.remove('modern-design');
        } else {
            document.body.classList.remove('home-page');
        }
        $(document).ready(function () {
            setTimeout(() => {
                $(".testimonial-slider").slick({
                    dots: true,
                    infinite: true,
                    speed: 300,
                    arrows: false,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    initialSlide: 0,
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                                infinite: true,
                                dots: true,
                            },
                        },
                        {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                            },
                        },
                    ],
                });
            }, 1000);
        });
    }, [location.pathname]);

    if (showPreloader) {
        return <CosmicOrbitLoader />;
    }

    return (
        <>
            <Helmet>
                {/* <title>Convert Webpage to PDF | Free Web to PDF Converter Online</title>
                <meta name="description" content="Instantly convert any webpage, website, or link to a PDF online. Use our free and fast web to PDF converter to save URLs, HTML, or websites as PDF documents." />
                <meta name="keywords" content="webpage to pdf, convert webpage to pdf, web to pdf converter" />
                <meta name="author" content="Webs2PDF" />
                <meta property="og:title" content="Convert Webpage to PDF | Free Web to PDF Converter Online" />
                <meta property="og:description" content="Instantly convert any webpage, website, or link to a PDF online. Use our free and fast web to PDF converter to save URLs, HTML, or websites as PDF documents." />
                <meta property="og:image" content="https://webs2pdf.com/images/Feature_Image.jpg" />
                <meta property="og:url" content="https://webs2pdf.com/" />
                <meta name="twitter:card" content="summary_large_image" />
                <link rel="canonical" href="https://webs2pdf.com" /> */}
                {/* Basic SEO */}
                <title>Convert Webpage to PDF | Free Web to PDF Converter Online</title>
                <meta
                    name="description"
                    content="Instantly convert any webpage, website, or link to a PDF online. Use our free and fast web to PDF converter to save URLs, HTML, or websites as PDF documents."
                />
                <meta
                    name="keywords"
                    content="webpage to pdf, convert webpage to pdf, web to pdf converter"
                />
                <meta name="author" content="Webs2PDF" />

                {/* Open Graph (Facebook, LinkedIn, WhatsApp) */}
                <meta
                    property="og:title"
                    content="Convert Webpage to PDF | Free Web to PDF Converter Online"
                />
                <meta
                    property="og:description"
                    content="Instantly convert any webpage, website, or link to a PDF online. Use our free and fast web to PDF converter to save URLs, HTML, or websites as PDF documents."
                />
                <meta
                    property="og:image"
                    content="https://webs2pdf.com/images/Feature_Image.jpg"
                />
                <meta property="og:url" content="https://webs2pdf.com/" />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="Webs2PDF" />

                {/* Twitter Card */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta
                    name="twitter:title"
                    content="Convert Webpage to PDF | Free Web to PDF Converter Online"
                />
                <meta
                    name="twitter:description"
                    content="Instantly convert any webpage, website, or link to a PDF online. Use our free and fast web to PDF converter to save URLs, HTML, or websites as PDF documents."
                />
                <meta
                    name="twitter:image"
                    content="https://webs2pdf.com/images/Feature_Image.jpg"
                />
                <meta name="twitter:site" content="@YourTwitterHandle" />

                {/* Canonical */}
                <link rel="canonical" href="https://webs2pdf.com" />
            </Helmet>
            <span id="home" style={{ visibility: 'hidden' }}></span>
            <Navbar isIndex />
            {/* Header END */}

            {/* BODY START */}

            {/* Hero Section start */}
            {/* <div className="hero-section-wrap"  >
        <div className="container">
            <div className="row">
                <div className="col-md-12 col-sm-12 col-12">
                    <h1 data-aos="fade-down">Convert web to PDF</h1>
                    <img src="images/hero.svg" data-aos="zoom-in"/>
                    <p  >Convert webpage to PDF with one click!</p>
                    <p   data-aos-delay="100">Copy and paste the webpage URL and click the <a
                            href="#">GET PDF</a> button.</p>
                    <form className="search-bar"   data-aos-delay="200">
                        <div className="input-container"  >
                            <i className="fas fa-link"></i>
                            <input type="text" placeholder="www.example.com" />
                        </div>
                        <button type="button" className="options-btn"   >OPTIONS</button>
                        <button type="submit" className="pdf-btn"    data-aos-delay="100">GET PDF</button>
                    </form>
                </div>
            </div>
        </div>
    </div> */}
            <DesktopModal show={showDesktopModal} onClose={handleCloseDesktopModal} />
            <WebToPdfSection />
            <div className="container useage" >
                <div className="row">
                    <div className="col-md-12">
                        <span>
                            *Size and daily usage limitations may apply.
                        </span>
                    </div>
                </div>
            </div>
            <div className="pdfonline-wrap pdfonline-wrap-grid"  >
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 col-12">

                            <h2>How to convert a webpage to PDF online</h2>
                            <div className="grid-container">
                                {/* Grid Item 1 */}
                                <div className="grid-item"  >
                                    <div className="image-section-new">
                                        <img src="images/how-111.svg" loading="lazy" alt="how to convert" />
                                    </div>
                                    <h2>1</h2>
                                    <h3>Copy</h3>
                                    <p className='para-bold'>Webpage or URL You Want to Convert</p>
                                    <p>Paste the link of any article, page, or online resource you want to save.</p>
                                </div>

                                {/* Grid Item 2 */}
                                <div className="grid-item"  >
                                    <div className="image-section-new">
                                        <img src="images/how-222.svg" loading="lazy" alt="click the Options" />
                                    </div>
                                    <h2>2</h2>
                                    <h3>Customize</h3>
                                    <p className='para-bold'>Conversion Settings (Optional)</p>
                                    <p>Click Options to adjust the layout, page size, orientation, margins, colors, and more.</p>
                                </div>

                                {/* Grid Item 3 */}
                                <div className="grid-item"  >
                                    <div className="image-section-new">
                                        <img src="images/how-333.svg" alt="Please wait" />
                                    </div>
                                    <h2>3</h2>
                                    <h3>Click</h3>
                                    <p className='para-bold'>“Convert” Button</p>
                                    <p>Our system will process your link instantly.</p>
                                </div>

                                {/* Grid Item 4 */}
                                <div className="grid-item"  >
                                    <div className="image-section-new">
                                        <img src="images/how-444.svg" loading="lazy" alt="Download" />
                                    </div>
                                    <h2>4</h2>
                                    <h3>Download</h3>
                                    <p className='para-bold'>Your PDF Instantly</p>
                                    <p>Your high-quality PDF will be ready in seconds, clean, accurate, and shareable.</p>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <PackagesSection />

            <div className="experience-wrap"  >
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 col-12">
                            <h3>Experience seamless  conversion at your fingertips!</h3>
                            <h4>Effortlessly transform any URL into a PDF with a single
                                click.</h4>
                            <p>Welcome to Webs2PDF, your all-in-one solution for converting web content into a versatile, easily shareable PDF format. Our tool is designed to meet
                                the needs of professionals, students, and casual users alike, providing a seamless and efficient way to capture and preserve online information.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="chose-wrap"  >
                <div className="container">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-md-6"  >
                            <h2>Why Choose Webs2PDF?</h2>
                            <span>For Professionals</span>
                            <p>Are you a researcher, journalist, or business
                                professional needing to archive web pages for future reference? Webs2PDF allows you to
                                effortlessly convert and store web content in a reliable PDF format, ensuring your important
                                information is always accessible, even offline.</p>

                            <span>For Students</span>
                            <p>Compiling resources for a project or thesis? Webs2PDF  simplifies the process by enabling you to quickly convert multiple URLs  into organized PDFs.
                                This makes it easier to annotate, highlight, and share your research with classNamemates and
                                professors.</p>

                            <span>For Everyday Users</span>
                            <p>Whether you're saving recipes, preserving articles, or
                                keeping track of your favorite blogs, Webs2PDF helps you maintain a personal archive of web
                                content that is easy to navigate and free from the clutter of advertisements and pop-ups.</p>
                        </div>
                        <div className="col-md-6">
                            <img src="images/why-choose.svg" loading="lazy" width="565px" height="413px" alt='Why choose' />
                        </div>
                    </div>
                </div>
            </div>

            <div className="feature-wrap"  >
                <div className="container">
                    <div className="row">
                        <h3>Key Features</h3>

                        <div className="col-md-3"  >
                            <div className="feature-box">
                                <h4>One-Click Conversion</h4>
                                <p>Transform any web page into a PDF with just one click, making the process fast
                                    and straightforward.</p>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="feature-box">
                                <h4>Customizable Options</h4>
                                <p>Choose from various settings to tailor the PDF output to your needs,including
                                    page size, orientation, and more.</p>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="feature-box private-wrap">
                                <h4>Secure and Private</h4>
                                <p>Your data security is our priority. Webs2PDF ensures that all conversions are
                                    handled with the utmost confidentiality and privacy.</p>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="feature-box multi-wrap">
                                <h4>Multi-Platform Support</h4>
                                <p>Accessible from any device, Webs2PDF allows you to convert web pages to PDFs
                                    whether you’re using a desktop, tablet, or smartphone.</p>
                            </div>
                        </div>

                        <h4>Webs2PDF is more than just a conversion tool; it's a gateway
                            to efficient and organized digital documentation.</h4>
                        <h4>Experience the convenience and power of seamless web content
                            conversion at your fingertips.</h4>
                    </div>
                </div>
            </div>

            <div className="learn-webs2pdf">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="section-divider"></div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 text-center">
                            <h3 className="section-title text-left">
                                Learn How Webs2PDF Helps You <br />
                                Convert and Preserve Web Content
                            </h3>
                        </div>
                    </div>

                    <div className="row content-row">
                        <div className="col-md-6">
                            <p>
                                Webs2PDF is your all-in-one solution for turning any webpage or online article into a clean, well-formatted, downloadable PDF. Whether you’re working on academic research, collecting references, saving tutorials, or archiving online reports, Webs2PDF makes the entire process quick, reliable, and professional.
                            </p>
                            <br></br>
                            <p>
                                Unlike basic browser print tools, Webs2PDF preserves the exact layout, images, links, and structure of the webpage. Everything is processed in real time, ensuring your PDF looks exactly how you expect, without ads, clutter, or broken formatting. This makes Webs2PDF the ideal tool for students, journalists, developers, teachers, office professionals, and anyone who needs reliable documentation.
                            </p>
                        </div>

                        <div className="col-md-6">
                            <p>
                                The platform works seamlessly across mobile, tablet, and desktop browsers. You don’t need to install any software; simply paste a link, customize if needed, and download your file. With support for multiple device sizes, high-quality outputs, custom watermarks, headers, footers, page numbers, and bulk conversion options, Webs2PDF offers unmatched flexibility for every use case.
                            </p>
                            <br></br>
                            <p>
                                If you regularly save web pages, need organized project documentation, or want easily shareable offline versions of online content, Webs2PDF simplifies everything. It ensures your content remains accessible, consistent, and professionally formatted, anytime, anywhere.
                            </p>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 text-center">
                            <div className="section-illustration">
                                {/* <img src="images/learn-webs2pdf.svg" loading="lazy" alt='Learn Webs2pdf' /> */}
                                <img src="https://webs2pdf.com/blog/wp-content/uploads/2025/12/New-SVG-1-scaled.png" loading="lazy" alt='Learn Webs2pdf' />
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className='feature-comparison'>
                <div className='container'>
                    <div className="row">
                        <div className="col-md-12 text-center">
                            <h3 className="text-left">
                                Feature Comparison
                            </h3>
                            <h4 className='sub-heading text-left'>See How Webs2PDF Stands Apart from Traditional and Alternative Solutions</h4>
                            <p className='text-left para'>Not all web-to-PDF tools are cut from the same cloth. This comparison highlights how Webs2PDF measures up against Chrome Print and other
                                common tools—showcasing where precision, quality, and flexibility truly matter. At a glance, you will see why Webs2PDF remains the dependable choice for professionals who value clean layouts, powerful controls, and seamless WordPress integration.<br></br>
                                Webs2PDF vs Chrome Print / Other Tools</p>
                        </div>
                    </div>                     
                    <div className="row feature-table-wrapper">
                        <div className="feature-table-scroll-wrapper">
                            <div className="col-md-3 feature-left">
                                <h4 className="feature-title">Feature</h4>

                                <ul className="feature-list">
                                    <li>Preserves layout & styling</li>
                                    <li>Removes ads & clutter</li>
                                    <li>Multiple page sizes</li>
                                    <li>High-quality rendering</li>
                                    <li>Bulk conversion</li>
                                    <li>Mobile optimization</li>
                                    <li>Custom watermarks</li>
                                    <li>WordPress integration</li>
                                </ul>
                            </div>

                            {/* COMPARISON TABLE */}
                            <div className="col-md-9 feature-right">
                                <div className="feature-table-box">
                                    <div className="feature-grid">

                                        <div className="webs2pdf">
                                            <h4 className="feature-title">Webs2PDF</h4>
                                            <ul className="feature-list">
                                                <li>Yes</li>
                                                <li>Yes</li>
                                                <li>Yes</li>
                                                <li>Yes</li>
                                                <li>Yes</li>
                                                <li>Yes</li>
                                                <li>Yes</li>
                                                <li>Yes</li>
                                            </ul>
                                        </div>

                                        <div className="others">
                                            <h4 className="feature-title">Chrome Print</h4>
                                            <ul className="feature-list">
                                                <li>No</li>
                                                <li>No</li>
                                                <li>No</li>
                                                <li>No</li>
                                                <li>No</li>
                                                <li className='limited'>Limited</li>
                                                <li>No</li>
                                                <li>No</li>
                                            </ul>
                                        </div>

                                        <div className="others">
                                            <h4 className="feature-title">Other Tools</h4>
                                            <ul className="feature-list">
                                                <li className='yes'>Yes | <span className='no'>No</span></li>
                                                <li className='limited'>Depends</li>
                                                <li className='limited'>Limited</li>
                                                <li className='yes'>Yes</li>
                                                <li className='no'>No | Paid</li>
                                                <li className='limited'>Limited</li>
                                                <li className='limited'>Rare</li>
                                                <li className='yes'>Yes | Paid</li>
                                            </ul>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                   
                </div>
            </div>


            <div className="virtual-wrap"  >
                <div className="container">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-md-6"  >
                            <span>Did you know?</span>
                            <h3>Webpage to PDF</h3>
                            <h4>The ultimate virtual print experience</h4>
                            <p>
                                Converting a webpage to PDF is akin to digitally printing your webpage, but with added benefits.
                                By transforming your HTML files into PDFs, you create an editable, customizable virtual copy
                                that also helps save paper! The quality of PDF conversions depends heavily on the webpage's
                                coding and its printer-friendliness. If a webpage appears strange when printed, it's likely to
                                appear similarly in PDF format. However, there are solutions available. Some websites provide an
                                embedded print button that renders the page's content in a preformatted version, ensuring a more
                                consistent PDF output.
                            </p>
                        </div>
                        <div className="col-md-6">
                            <img src="images/did-you-know.svg" loading="lazy" width="565px" height="565px" className="img-responsive" alt='Did you know' />
                        </div>
                    </div>
                </div>
            </div>

            <div className="benefits-wrap" id="benefit"  >
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h2>Benefits of using Webs2PDF</h2>
                            <p>Unlock the full potential of your web content with Webs2PDF. Convert, customize, and securely save web pages as PDFs, ensuring you have access to important information whenever you need it.
                                Explore the key advantages of using our tool to enhance your productivity and document management.</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="benefit-box "  >
                                <div className="img-div">
                                    <img src="images/user.webp" loading="lazy" width="60px" height="60px" alt='User' />
                                </div>
                                <div className="benefit-details user-friendy-wrap">
                                    <span>User Friendly</span>
                                    <p>Designed for simplicity, ensuring a seamless experience with no need for techn expertise.</p>
                                </div>
                            </div>
                            <div className="benefit-box">
                                <div className="img-div">
                                    <img src="images/fast.webp" loading="lazy" width="60px" height="60px" alt='Fast and Reliable' />
                                </div>
                                <div className="benefit-details fast-wrap">
                                    <span>Fast and Reliable</span>
                                    <p>Count on our robust servers for prompt and trouble-free conversions, ensuring a
                                        seamless experience.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="benefit-box">
                                <div className="img-div">
                                    <img src="images/quality.webp" loading="lazy" width="60px" height="60px" alt='High Quality Outputs' />
                                </div>
                                <div className="benefit-details high-wrap">
                                    <span>High Quality Outputs</span>
                                    <p>Enjoy pristine PDFs in every conversion, ensuring an exceptional viewing experience.
                                    </p>
                                </div>
                            </div>
                            <div className="benefit-box">
                                <div className="img-div">
                                    <img src="images/benefits.webp" loading="lazy" width="70px" height="70px" alt='Simplify file sharing' />
                                </div>
                                <div className="benefit-details">
                                    <span>Simplify file sharing with PDFs</span>
                                    <p>A universal format accessible on computers and mobile devices, ensuring easy sharing
                                        of web content with others.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="user-wrap"  >
                <div className="container">
                    <div className="row">
                        <div className="col-md-12" id="reviews">
                            <h3>Real User Experiences</h3>
                            <p>
                                Discover the impact Webs2PDF is making through user reviews.
                                Learn how it enhances productivity, organization, and overall
                                efficiency in document management.
                            </p>
                            <img src="images/reviews.svg" loading="lazy" width="1150px" height="541px" alt="Reviews" className="img-responsive" />
                            <div className="testimonial-slider">
                                <div className="testimonial-item" >
                                    <div className="testimonial-content">
                                        <i className="fa-regular fa-user"></i>
                                        <p>Webs2PDF has been a game-changer for my work. As a researcher, I often need to
                                            save web pages for offline reading and reference. This tool makes it so easy
                                            to convert web pages to PDF with just a few clicks. It has significantly
                                            improved my productivity and organization. I highly recommend it!</p>
                                        <h3>Sarah Lawrence</h3>
                                        <p>RESEARCHER</p>
                                    </div>
                                </div>
                                <div className="testimonial-item">
                                    <div className="testimonial-content">
                                        <i className="fa-regular fa-user"></i>
                                        <p>I use Webs2PDF daily for my job, and it has made managing documents so much
                                            easier. The conversion process is quick and the quality of the PDFs is
                                            excellent. Plus, I love that I don't need to download any software.
                                            It's a must-have tool for anyone dealing with web content regularly.</p>
                                        <h3>James Peterson</h3>
                                        <p>MARKETING MANAGER</p>
                                    </div>
                                </div>
                                <div className="testimonial-item">
                                    <div className="testimonial-content">
                                        <i className="fa-regular fa-user"></i>
                                        <p>Webs2PDF is a fantastic tool for anyone who needs to save web pages for later
                                            use. It is especially useful for creating printable versions of web content.
                                            The interface is user-friendly, and the service is reliable. This tool has
                                            definitely increased my efficiency in handling documents.</p>
                                        <h3>Emily Roberts</h3>
                                        <p>FREELANCE WRITER</p>
                                    </div>
                                </div>
                                <div className="testimonial-item">
                                    <div className="testimonial-content">
                                        <i className="fa-regular fa-user"></i>
                                        <p>Webs2PDF is a fantastic tool for anyone who needs to save web pages for later
                                            use. It is especially useful for creating printable versions of web content.
                                            The interface is user-friendly, and the service is reliable. This tool has
                                            definitely increased my efficiency in handling documents.</p>
                                        <h3>Emily Roberts</h3>
                                        <p>FREELANCE WRITER</p>
                                    </div>
                                </div>
                                <div className="testimonial-item" data-aos-delay="400">
                                    <div className="testimonial-content">
                                        <i className="fa-regular fa-user"></i>
                                        <p>Webs2PDF is a fantastic tool for anyone who needs to save web pages for later
                                            use. It is especially useful for creating printable versions of web content.
                                            The interface is user-friendly, and the service is reliable. This tool has
                                            definitely increased my efficiency in handling documents.</p>
                                        <h3>Emily Roberts</h3>
                                        <p>FREELANCE WRITER</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="broswer-wrap">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h2>Supported Browsers</h2>
                            <p>Our online HTML to PDF converter seamlessly supports the latest versions of all major browsers,
                                ensuring compatibility with Chrome, Firefox, Edge, Safari, Opera, Internet Explorer, Vivaldi, and Brave. This ensures a
                                versatile user  experience across different platforms and devices.
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="icon-container">
                                <img src="images/chrome.webp" loading="lazy" width="100px" height="100px" alt="Chrome" className="icon" />
                                <img src="images/firefox.webp" loading="lazy" width="100px" height="100px" alt="Firefox" className="icon" />
                                <img src="images/edge.webp" loading="lazy" width="100px" height="100px" alt="Edge" className="icon" />
                                <img src="images/safari.webp" loading="lazy" width="100px" height="100px" alt="Safari" className="icon" />
                                <img src="images/opera.webp" loading="lazy" width="100px" height="100px" alt="Opera" className="icon" />
                                <img src="images/brave.webp" loading="lazy" width="100px" height="100px" alt="Brave" className="icon" />
                                <img src="images/vivaldi.webp" loading="lazy" width="100px" height="100px" alt="Vivaldi" className="icon" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* 
            <div className="plan-wrap" data-aos-duration="1000">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 plan-details" data-aos-duration="1500">
                            <h3>Find the perfect plan for your needs</h3>
                            <h4>Explore Our Flexible Pricing Options</h4>
                            <p>Discover the plan that best fits your requirements and start converting web pages to PDFs with
                                ease. Whether you're a<br />
                                casual user or need extensive features, our pricing plans offer flexibility and value to suit
                                your needs. <br />
                                Choose the right plan and enjoy seamless document management today!</p>
                        </div>
                    </div>
                </div>
            </div> */}

            <div className="webs2pdf-blog">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 heading-wrap">
                            <h3 className="section-title text-left">
                                Webs2PDF Blog
                            </h3>
                            <p>Step into our corner of ideas, where simple tools turn into smarter workflows. Here you’ll find tips, guides, and inspiration to help you transform web pages into polished PDFs with ease. Stay tuned for practical know-how, thoughtful insights, and a touch of creativity to keep your digital world organized and stress-free.</p>
                        </div>
                        <div className="col-md-12">
                            {blogLoading ? (
                                <div style={{ textAlign: 'center', padding: '40px' }}>
                                    <p>Loading blog posts...</p>
                                </div>
                            ) : blogPosts.length > 0 ? (
                                <div className="blog-slider">
                                    {blogPosts.map((post) => (
                                        <div key={post.id} className="blog-featured-item">
                                            <a href={post.link} style={{ display: 'block', textDecoration: 'none' }}>
                                                <img 
                                                    src={getFeaturedImage(post)} 
                                                    loading="lazy" 
                                                    width="100%" 
                                                    height="auto" 
                                                    alt={post.title?.rendered || 'Blog post'} 
                                                    onError={(e) => {
                                                        const postTitle = post.title?.rendered || '';
                                                        // Use specific image for "Save Web Pages as High-Quality PDF Without Installing Any App"
                                                        if (postTitle === 'Save Web Pages as High-Quality PDF Without Installing Any App') {
                                                            (e.target as HTMLImageElement).src = 'https://webs2pdf.com/blog/wp-content/uploads/2025/12/Save-Web-Pages-as-High-Quality-PDF-Without-Installing-Any-App-scaled.jpg';
                                                        } else {
                                                            (e.target as HTMLImageElement).src = 'images/blog1.webp';
                                                        }
                                                    }}
                                                />
                                            </a>
                                            <p><span>{formatDate(post.date)}</span></p>
                                            <a href={post.link} style={{ textDecoration: 'none', display: 'block' }}>
                                                <h4 dangerouslySetInnerHTML={{ __html: post.title?.rendered || '' }}></h4>
                                            </a>
                                            <p>{getExcerpt(post.excerpt?.rendered || post.content?.rendered || '')}</p>
                                            <a href={post.link} className="read-more">read more</a>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div style={{ textAlign: 'center', padding: '40px' }}>
                                    <p>No blog posts available at the moment.</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="faq-wrap" >
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 faq-details">
                            <h2>Frequently Asked Questions</h2>
                            <p>Webs2pdf is your go-to tool for converting web pages into PDF documents quickly and easily.
                                Whether you're looking to save web content for offline reading or create printable versions of web pages, Webs2pdf has got you
                                covered. Here are the answers to some frequently asked questions to help you make the most of this powerful online tool.</p>
                        </div>
                    </div>
                    <div className="row justify-content-center align-items-center" id="faq">
                        <div className="col-md-6">
                            <div className="accordion" id="accordionExample">
                                <div className="accordion-item">
                                    <h3 className="accordion-header" id="headingOne">
                                        <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                            <i className="fas fa-angles-right"></i>
                                            What is Webs2pdf?
                                        </button>
                                    </h3>
                                    <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne"
                                        data-bs-parent="#accordionExample">
                                        <div className="accordion-body">
                                            Webs2pdf is an online tool that allows you to convert web pages into PDF documents
                                            quickly and easily. It is designed to help users save web content in a portable and
                                            printable format.
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item">
                                    <h3 className="accordion-header" id="headingTwo">
                                        <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                            <i className="fas fa-angles-right"></i>
                                            Is Webs2pdf free to use?
                                        </button>
                                    </h3>
                                    <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo"
                                        data-bs-parent="#accordionExample">
                                        <div className="accordion-body">
                                            Yes, Webs2pdf offers a free version that allows users to convert web pages to PDF
                                            without any cost. However, there may be additional features or higher usage limits
                                            available through paid plans.
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h3 className="accordion-header" id="headingThree">
                                        <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                            <i className="fas fa-angles-right"></i>
                                            Do I need to download any software to use Webs2pdf?
                                        </button>
                                    </h3>
                                    <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree"
                                        data-bs-parent="#accordionExample">
                                        <div className="accordion-body">
                                            No, you do not need to download any software to use Webs2pdf. It is a web-based tool,
                                            so you can access and use it directly from your browser.        </div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h3 className="accordion-header" id="headingFour">
                                        <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                            <i className="fas fa-angles-right"></i>
                                            How do I convert a web page to a PDF using Webs2pdf?
                                        </button>
                                    </h3>
                                    <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour"
                                        data-bs-parent="#accordionExample">
                                        <div className="accordion-body">
                                            To convert a web page to a PDF using Webs2pdf, follow these steps:
                                            <ul>
                                                <li>Go to the Webs2pdf website.</li>
                                                <li>Enter the URL of the web page you want to convert in the provided input
                                                    field.</li>
                                                <li>Click the "Convert" button.</li>
                                                <li>Wait for the conversion to complete.</li>
                                                <li>Download the resulting PDF file to your device.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h3 className="accordion-header" id="headingFive">
                                        <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                            <i className="fas fa-angles-right"></i>
                                            Can I convert multiple web pages at once?
                                        </button>
                                    </h3>
                                    <div id="collapseFive" className="accordion-collapse collapse" aria-labelledby="headingFive"
                                        data-bs-parent="#accordionExample">
                                        <div className="accordion-body">
                                            Webs2pdf typically allows you to convert one web page at a time. If you need to
                                            convert multiple web pages, you will need to repeat the conversion process for each
                                            URL. Some advanced or paid versions may offer batch conversion features.
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h3 className="accordion-header" id="headingSix">
                                        <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                                            <i className="fas fa-angles-right"></i>
                                            Are there any limits on the number of PDF conversions?
                                        </button>
                                    </h3>
                                    <div id="collapseSix" className="accordion-collapse collapse" aria-labelledby="headingSix"
                                        data-bs-parent="#accordionExample">
                                        <div className="accordion-body">
                                            The free version of Webs2pdf may have limits on the number of PDF conversions you can
                                            perform within a certain time frame. These limits can vary, so it's best to check
                                            the website for specific details. Paid plans often offer higher or unlimited
                                            conversion limits.
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h3 className="accordion-header" id="headingSeven">
                                        <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                                            <i className="fas fa-angles-right"></i>
                                            What customization options are available for PDF conversion?
                                        </button>
                                    </h3>
                                    <div id="collapseSeven" className="accordion-collapse collapse" aria-labelledby="headingSeven"
                                        data-bs-parent="#accordionExample">
                                        <div className="accordion-body">
                                            Webs2pdf offers various customization options for PDF conversion, including:
                                            <ul>
                                                <li>Selecting the page size and orientation (e.g., A4, Letter, portrait,
                                                    landscape).
                                                </li>
                                                <li>Adjusting margins.</li>
                                                <li>Including or excluding images and links.</li>
                                                <li>Setting a header and footer.</li>
                                                <li>Configuring other advanced settings depending on the specific requirements.
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h3 className="accordion-header" id="headingEight">
                                        <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseEight" aria-expanded="false" aria-controls="collapseEight">
                                            <i className="fas fa-angles-right"></i>
                                            Is Webs2pdf mobile-friendly?
                                        </button>
                                    </h3>
                                    <div id="collapseEight" className="accordion-collapse collapse" aria-labelledby="headingEight"
                                        data-bs-parent="#accordionExample">
                                        <div className="accordion-body">
                                            Yes, Webs2pdf is mobile-friendly. You can access and use the tool on your mobile
                                            device’s browser, allowing you to convert web pages to PDFs on the go.
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h3 className="accordion-header" id="headingNine">
                                        <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseNine" aria-expanded="false" aria-controls="collapseNine">
                                            <i className="fas fa-angles-right"></i>
                                            Can I use Webs2pdf without registering?
                                        </button>
                                    </h3>
                                    <div id="collapseNine" className="accordion-collapse collapse" aria-labelledby="headingNine"
                                        data-bs-parent="#accordionExample">
                                        <div className="accordion-body">
                                            Yes, you can use Webs2pdf without registering. The tool is designed to be
                                            user-friendly and accessible without the need for creating an account or signing in.
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h3 className="accordion-header" id="headingTen">
                                        <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseTen" aria-expanded="false" aria-controls="collapseTen">
                                            <i className="fas fa-angles-right"></i>
                                            Is the conversion process secure and private?
                                        </button>
                                    </h3>
                                    <div id="collapseTen" className="accordion-collapse collapse" aria-labelledby="headingTen"
                                        data-bs-parent="#accordionExample">
                                        <div className="accordion-body">
                                            Yes, the conversion process is secure and private. Webs2pdf ensures that your data and web pages are handled with confidentiality and are not stored or shared with third parties.</div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h3 className="accordion-header" id="headingEleven">
                                        <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseEleven" aria-expanded="false" aria-controls="collapseEleven">
                                            <i className="fas fa-angles-right"></i>
                                            What file formats can I convert to PDF using Webs2pdf?
                                        </button>
                                    </h3>
                                    <div id="collapseEleven" className="accordion-collapse collapse" aria-labelledby="headingEleven"
                                        data-bs-parent="#accordionExample">
                                        <div className="accordion-body">
                                            Webs2pdf primarily focuses on converting web pages to PDF format. However, some versions may offer additional file format support for converting documents to PDF.</div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h3 className="accordion-header" id="headingTwelve">
                                        <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseTwelve" aria-expanded="false" aria-controls="collapseTwelve">
                                            <i className="fas fa-angles-right"></i>
                                            How do I contact customer support if I encounter issues?
                                        </button>
                                    </h3>
                                    <div id="collapseTwelve" className="accordion-collapse collapse" aria-labelledby="headingTwelve"
                                        data-bs-parent="#accordionExample">
                                        <div className="accordion-body">
                                            If you encounter any issues, you can contact Webs2pdf’s customer support through their website’s contact form or support email. Detailed contact information is typically available on the website’s support or help section.</div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h3 className="accordion-header" id="headingThirteen">
                                        <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseThirteen" aria-expanded="false" aria-controls="collapseThirteen">
                                            <i className="fas fa-angles-right"></i>
                                            Is Webs2pdf compatible with all web browsers?
                                        </button>
                                    </h3>
                                    <div id="collapseThirteen" className="accordion-collapse collapse" aria-labelledby="headingThirteen"
                                        data-bs-parent="#accordionExample">
                                        <div className="accordion-body">
                                            Yes, Webs2pdf is compatible with all major web browsers, including Chrome, Firefox, Safari, and Edge, ensuring a seamless experience regardless of your preferred browser.</div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h3 className="accordion-header" id="headingFourteen">
                                        <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseFourteen" aria-expanded="false" aria-controls="collapseFourteen">
                                            <i className="fas fa-angles-right"></i>
                                            Are there any restrictions on the types of web pages?
                                        </button>
                                    </h3>
                                    <div id="collapseFourteen" className="accordion-collapse collapse" aria-labelledby="headingFourteen"
                                        data-bs-parent="#accordionExample">
                                        <div className="accordion-body">
                                            Webs2pdf can convert most types of web pages, but there may be restrictions on certain dynamic or interactive web pages that rely heavily on JavaScript or other technologies that are not easily rendered in a PDF format. </div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h3 className="accordion-header" id="headingThirteen">
                                        <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseFifteen" aria-expanded="false" aria-controls="collapseFifteen">
                                            <i className="fas fa-angles-right"></i>
                                            Can I convert a website to PDF for free?
                                        </button>
                                    </h3>
                                    <div id="collapseFifteen" className="accordion-collapse collapse" aria-labelledby="headingFifteen"
                                        data-bs-parent="#accordionExample">
                                        <div className="accordion-body">
                                            Yes, absolutely! We offer up to 3 free web page-to-PDF conversions per day — no signup required. It's fast, easy, and completely free to get started.
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item">
                                    <h3 className="accordion-header" id="headingThirteen">
                                        <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseSixteen" aria-expanded="false" aria-controls="collapseSixteen">
                                            <i className="fas fa-angles-right"></i>
                                            Does this work for HTML or articles?
                                        </button>
                                    </h3>
                                    <div id="collapseSixteen" className="accordion-collapse collapse" aria-labelledby="headingSixteen"
                                        data-bs-parent="#accordionExample">
                                        <div className="accordion-body">
                                            Yes, it supports both HTML pages and articles. As long as the content is accessible through the provided URL, the tool captures and converts the web page into a PDF that closely matches how it appears in your browser, maintaining layout and formatting.
                                        </div>
                                    </div>
                                </div>




                            </div>
                        </div>

                        <div className="col-md-6">
                            <img src="images/faq.svg" loading="lazy" width="565px" height="565px" className="img-responsive" alt='Faqs' />
                        </div>
                    </div>
                </div >
            </div >

            <div className="about-webs2pdf-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="about-content">
                                <p className="about-text">
                                    Webs2PDF was created by the Webs2PDF Team at Hashe Developers to make digital documentation <strong className="highlight-text">simple, accessible, and reliable.</strong>
                                </p>
                                <p className="stats-text">
                                    Over <strong>1.5 million+</strong> pages converted since 2023
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            
            <ContactUsSection />
            {/* Footer */}

            <Footer />
        </>
    );
}
export default WebToPDF;
